import styled from 'styled-components';
import YoutubeIcon from '@/assets/icon/logo-youtube.svg?react';
import BlogIcon from '@/assets/icon/logo-blog.svg?react';
import KakaoIcon from '@/assets/icon/logo-kakao.svg?react';
import InstaIcon from '@/assets/icon/logo-insta.svg?react';
import AllbadeumIcon from '@/assets/icon/allbadeum.svg?react';

export default function Footer() {
  return (
    <Wrapper>
      <Container>
        <LinkGroup>
          <AllbadeumIcon />
          <FooterLink href="/privacy" active>
            개인정보 처리방침
          </FooterLink>
          <FooterLink href="/intro/about">회사소개</FooterLink>
          <FooterLink href="/terms">이용약관</FooterLink>

          <SocialGroup>
            <a href="https://www.youtube.com/@TV-by1br" target="_blank" rel="noopener noreferrer">
              <SocialIconWrapper>
                <YoutubeIcon />
              </SocialIconWrapper>
            </a>
            <a href="https://blog.naver.com/allbadeum" target="_blank" rel="noopener noreferrer">
              <SocialIconWrapper>
                <BlogIcon />
              </SocialIconWrapper>
            </a>
            <a
              href="https://www.instagram.com/all_badeum/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <SocialIconWrapper>
                <InstaIcon />
              </SocialIconWrapper>
            </a>
            <a href="http://pf.kakao.com/_jSxgGxj/chat" target="_blank" rel="noopener noreferrer">
              <SocialIconWrapper>
                <KakaoIcon />
              </SocialIconWrapper>
            </a>
          </SocialGroup>
        </LinkGroup>
      </Container>

      <Border />

      <InfoContainer>
        <InfoText>
          <InfoHighlight>올받음손해사정(주)</InfoHighlight> | 손해사정 서비스
        </InfoText>
        <InfoText>서울특별시 영등포구 여의나루로 67, 1205-ES24 (여의도동, 신송빌딩)</InfoText>
        <InfoText>
          올받음손해사정(주) 대표 염선무 | 사업자등록번호 291-81-03198
          <br />
          손해사정업 등록번호 B0000801
        </InfoText>
        <InfoText>
          <InfoHighlight>어슈런스(주)</InfoHighlight> | IT 서비스
        </InfoText>
        <InfoText>
          서울특별시 영등포구 의사당대로 83, 서울핀테크랩 17층 115호(여의도동, 오투타워)
        </InfoText>
        <InfoText>
          어슈런스 주식회사 대표 염선무 | 사업자등록번호 117-87-02855
          <br />
          E-mail allbadeum@gmail.com | Icons by icon8.com
        </InfoText>
      </InfoContainer>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  width: 100%;
  background-color: #000c24;
  color: white;
`;

const Container = styled.div`
  max-width: 1441px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 33px 16px 20px;

  @media (min-width: 640px) {
    flex-direction: row;
    padding: 33px 108px 20px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

const LinkGroup = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;

  @media (min-width: 640px) {
    flex-direction: row;
    align-items: center;
    gap: 38px;
  }
`;

const FooterLink = styled.a<{ active?: boolean }>`
  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
  letter-spacing: -0.28px;
  color: ${({ active }) => (active ? 'white' : '#949494')};
  text-decoration: none;
`;

const SocialGroup = styled.div`
  display: none;

  @media (min-width: 640px) {
    display: flex;
    gap: 16px;
    margin-left: auto;
    margin-top: 0;
    align-items: center;
  }
`;

const SocialIconWrapper = styled.div`
  width: 32px;
  height: 32px;

  svg {
    width: 100%;
    height: 100%;
  }
`;

const Border = styled.div`
  width: 100%;
  max-width: 1225px;
  margin: 0 auto;
  border-top: 1px solid #858e96;
  padding: 0 16px;

  @media (min-width: 640px) {
    padding: 0 108px;
  }
`;

const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  max-width: 1440px;
  margin: 0 auto;
  padding: 24px 16px;
  color: #949494;

  @media (min-width: 640px) {
    padding: 24px 108px;
  }
`;

const InfoText = styled.p`
  font-size: 14px;
  font-weight: 350;
  line-height: 21px;
  letter-spacing: -0.28px;
  margin-bottom: 8px;
  text-align: start;
`;

const InfoHighlight = styled.span`
  font-weight: 500;
  color: white;
`;
